import { axiosContentDetail, axiosHomeScreen } from "../axios";
import { getContentWithLanguage } from "../util/language";
import { SEE_ALL_ACTIONS } from "./actionTypes";
import { handleActionError } from "../util/error";

const LatestRail = "/pub/api/v1/vod/latest";
const homeSectionUrl = "/section/";

export const getSeeAllDataAction = ({ offset = 0, max = 12, language }) => {
  return dispatch => {
    dispatch({
      type: SEE_ALL_ACTIONS.SEE_ALL_VIDEO._START,
      payload: { offset }
    });
    return axiosContentDetail
      .get(`${LatestRail}?offset=${offset}&max=${max}`)
      .then(response => {
        const { data = {} } = response;
        const filteredByLanguage = getContentWithLanguage(data.data, language);
        dispatch({
          type: SEE_ALL_ACTIONS.SEE_ALL_VIDEO._SUCCESS,
          payload: { data: filteredByLanguage, offset }
        });
      })
      .catch(error => {
        handleActionError("An error occurred while getting data for the Latest rail:", error);
        dispatch({
          type: SEE_ALL_ACTIONS.SEE_ALL_VIDEO._FAILURE
        });
      });
  };
};

export const getHomePageSectionSeeAll = ({ sectionId, language }) => {
  return dispatch => {
    dispatch({
      type: SEE_ALL_ACTIONS.HOME_PAGE_SECTION._START
    });
    return axiosHomeScreen
      .get(homeSectionUrl + sectionId)
      .then(response => {
        const { data = {} } = response;
        const filteredByLanguage = getContentWithLanguage(data, language);
        dispatch({
          type: SEE_ALL_ACTIONS.HOME_PAGE_SECTION._SUCCESS,
          payload: { data: filteredByLanguage }
        });
      })
      .catch(error => {
        handleActionError("An error occurred while getting home page section data:", error);
        dispatch({
          type: SEE_ALL_ACTIONS.HOME_PAGE_SECTION._FAILURE
        });
      });
  };
};

export const setManualRailData = (data, offset = 0) => {
  return dispatch => {
    dispatch({
      type: SEE_ALL_ACTIONS.SET_MANUAL_SEE_ALL,
      payload: { data: data, offset }
    });
  };
};
